
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

// 盒子列表
// {
//   BoxId: 1
//   Description: "description-ff"
//   ModifyTime: 1555655636
//   Status: "unlocked" locked
//   Title: "4期盒子修改-ff"
//   Type: "video"
//   LastCoursesId: 0
//   Finished: 0  >=10 完成
//   Url: "http://videovideo"
// }
const boxitem = {
  BoxId: 1,
  Description: "",
  Status: "locked",
  Title: "",
  Type: "",
  LastCoursesId: 0, // 2366
  Finished: 0,
  Url: "",
}
let initBox = []
for(let i = 1; i<13; i++ ) {
  initBox.push(Object.assign({}, boxitem, {BoxId: i}))
}

export const boxesListdata = (state = initBox, action) => {
  switch (action.type) {
    case 'SETBOXESLISTDATA':
      var olddata = state
      var data = []
      olddata.map((item, index) => {
        data.push(Object.assign({}, item, action.value[index]))
      })
      // console.log(data)
      return data

    default:
      return state
  }
}


// 盒子详情
const initboxDetail = {
  Description: {
    Title: '',
    Description: '',
    Type: 'video',
    Url: '',
    BoxId: 1
  },
  List: [],
  VideoList: []
}
export const boxDetail = (state = initboxDetail, action) => {
  switch (action.type) {
    case 'SETBOXESDETAILDATA':
    // console.log(action.value)
      return action.value

    default:
      return state
  }
}

function isArray(o){
  return Object.prototype.toString.call(o) === '[object Array]';
}
// 储存盒子系列的当前预览步骤
let initBoxCount = []
let initLocalStorage = JSON.parse(localStorage.getItem('boxSeriesCount'))
if (initLocalStorage && isArray(initLocalStorage) && initLocalStorage.length === 12) {
  initBoxCount = initLocalStorage
} else {
  for(let i = 1; i<13; i++ ) {
    initBoxCount.push({BoxId: i, count: 0})
  }
}
export const boxSeriesCount = (state = initBoxCount, action) => {
  switch (action.type) {
    case 'SETBOXSERIESCOUNT':
      var data = state.slice(0)
      data[action.index].count = action.value
      // console.log(data)
      localStorage.setItem('boxSeriesCount', JSON.stringify(data))
      return data

    default:
      return state
  }
}

// 步骤数据
export const stepsData = (state = [], action) => {
  switch (action.type) {
    case 'SETSTEPSDATA':
      // console.log(action.value)
      return action.value

    case 'SETANSWER':
      var data = state.slice(0)
      data[action.index].contents.myAnswer = action.value
      data[action.index].contents.options.map(item => {
        item.showTips = false
      })
      // console.log(action.value)
      return data

    case 'SHOWTIPS':
      var data = state.slice(0)
      data[action.index].contents.options.map((item, index) => {
        if (index === action.eq) {
          item.showTips = true
        }
      })
      // console.log(action.value)
      return data

    default:
      return state
  }
}

// 学习进度
export const stepIndex = (state = -1, action) => {
  switch (action.type) {
    case 'SETSTEPINDEX':
      return action.index

    default:
      return state
  }
}

// 显示完成勋章弹窗
export const showMedal = (state = false, action) => {
  switch (action.type) {
    case 'SHOWMEDALPOP':
      return action.data

    default:
      return state
  }
}

// 步骤的勋章列表
export const medalListData = (state = [], action) => {
  switch (action.type) {
    case 'GETMEDALLIST':
      return action.data

    default:
      return state
  }
}

// 勋章页的勋章列表
export const myMdeals = (state = [], action) => {
  switch (action.type) {
    case 'GETMYDEDALS':
    // console.log(action.data)
      return action.data

    default:
      return state
  }
}

// 勋章页统计勋章数量
export const myMdealsTotal = (state = { total: 0, lighted: 0, Beliel: 0 }, action) => {
  switch (action.type) {
    case 'GETMYDEDALSTOTAL':
      // console.log(action.data)
      return action.data

    default:
      return state
  }
}

// 帐号是否有权限
export const permission = (state = null, action) => {
  switch (action.type) {
    case 'SETPERMISSION':
      return action.data

    default:
      return state
  }
}

// 视频移动的时候
export const videoIsMoved = (state = false, action) => {
  switch (action.type) {
    case 'EXVIDEOMOVED':
      return action.data

    default:
      return state
  }
}

// 盒子最后一节课
// LastCoursesId
export const lastCoursesId = (state = 0, action) => {
  switch (action.type) {
    case 'SETLASTCOURSESID':
      return action.id

    default:
      return state
  }
}

// 盒子弹窗
export const showBoxIndex = (state = null, action) => {
  switch (action.type) {
    case 'SETSHOWBOXINDEX':
      return action.index

    default:
      return state
  }
}

// mloading
export const isMloading = (state = false, action) => {
  switch (action.type) {
    case 'SETMLOADING':
      return action.value

    default:
      return state
  }
}